var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.componentName !== null)?_c('div',{ref:"wrapper"},[_c(_vm.componentName,_vm._b({tag:"component",attrs:{"is-loading":_vm.isLoading}},'component',_vm.content,false))],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }